export const DEFAULT_VALUES = {
	from: '',
	till: '',
	fromTime: '',
	tillTime: '',
	fromLocation: '',
	toLocation: '',
	note: '',
};
